module.exports = __webpack_public_path__ + "media/images/common/setting_btn_s_ov-6d7ccc374f88d8c6f826c0542c84a3f5.png";